<template>
    <div>
        <h3>ユーザー登録</h3>
        <div>
            <p>
                貸し本棚のユーザー登録は、２種類の方法があります。
                ひとつはメールアドレスとパスワードを登録する方法、もう一つは、
                ユーザー自身がお使いのGoogleアカウントと連携して登録する方法です。
            </p>
            <h4>メールアドレスとパスワード登録</h4>
            <p>
                ユーザー登録画面で、お名前、メールアドレス、パスワードを入力して「ユーザー登録」ボタンを押してください。
                入力情報に問題がなければそのままログインします。
                入力内容に不備がある場合、エラーメッセージが表示されます。<br>
            </p>
            <h4>メールアドレスの承認</h4>
            <p>
                登録したメールアドレスに、確認メールが送信されていますので、認証を行ってください。
                メールアドレスの存在確認が行われないと、サブドメインを取得することができません（小説の投稿はできます）。
                メールアドレス未承認状態のアカウントは、長期間ログインなどの処理が行われないと、削除されることがあります。
            </p>
            <h5>送受信できなメールアドレスでの登録</h5>
            <p>
                送受信できないメールアドレスでの登録は推奨していません。
                何らかの事情で送受信可能なメールアドレスの登録に支障がある場合は、お問い合わせより運営にご相談ください。
                メール関連機能が利用できない制限ユーザーとして承認することができます。
            </p>
            <p>
                この手動承認作業は時間がかかることがあり、承認依頼が多い場合は一時的に作業を停止することがあります。
            </p>
            <h4>連携ログインによる登録</h4>
            <p>
                Googleのアカウントをお持ちの方は、それぞれのアカウントにログインした状態で、
                Googleでログインボタンを押してください。
                自動的にユーザー登録し、そのままログインします。<br>
                次回ログイン時も、同様に連携ログインのボタンからログインしてください。
            </p>
            <p>
                Googleなどで複数アカウントに同時にログインされている場合、いずれのアカウントを使用するか選択画面が表示されます。
            </p>
            <p>
                連携ログインのアカウントは自動的にメールアドレスの承認が行われます。
                但し、メールアドレスを変更することはできません。
            </p>
            <h4>制限ユーザー</h4>
            <p>
                運営が許可したユーザーは「制限ユーザー」となり、メール関連機能が使えなくなります。
                自分が制限ユーザーかどうかを確認するには、アカウント設定画面のユーザー情報に表記されているメールアドレスの右側のアイコンを確認してください。<br>
                <span class="badge badge-danger badge-pill"><i class="fas fa-user-lock"></i></span>←こういうアイコンが表記されているユーザーは制限ユーザです。
            </p>
            <p>
                もし、送受信が可能なメールアドレスに変更された場合は、制限の解除を申請してください。
                そのままメールアドレスを変更して承認されても、制限ユーザーは解除されません。
            </p>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "ユーザー登録 | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>